<template>
    
    <div class="row mt-1 mb-2">
      <div class='product-selector col-12 py-3'>
        <div class="row">


          <div class="col-12 col-sm-6 col-md-6 pl-5 pl-md-5 ">
            <div class='name'> {{ product.name }}  </div>
            <div>
              <div class='price-wrap'>
                {{product.currentPriceObj.antiquePrice}}
                <price
                  v-if="product.currentPriceObj.antiquePrice != product.currentPriceObj.price && product.currentPriceObj.antiquePrice"
                  class='f5 antiqueprice' :price="product.currentPriceObj.antiquePrice"></price>
                <price class='f4' :price="product.price"></price>

                <template v-for=" price of product.prices">
                    
                    <div v-if="price.price != product.price && !price.finish">
                        à partir de<date :date="price.date"  format="D MMMM" />
                        - R$ {{ price.price }}
                    </div>
                </template>
                <!-- <pre>{{ product.prices }}</pre> -->
              </div>

              <div class='o-60 pointer' v-if="product.description" @click="infoOpen = !infoOpen">
                <ico icon="plus"></ico> info
              </div>
              <div v-if="infoOpen" v-html="product.description"> </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 tc">

                <hr class='d-block d-sm-none' />
            <div class="d-flex align-items-center justify-content-around justify-sm-content-end mr-sm-2 ">
                <div class='quantity-selector'>
                <quantity-chooser v-model="quantity"></quantity-chooser>
                </div>
                <div>
                <button @click="quantity++" class='btn btn-warning btn-small w-100 w-sm-auto'> Adicionar</button>
                </div>
            </div>
          </div>
          
         

        </div>
      </div>
    </div>

</template>

<script>
import product from '../../../../common/models/product';

export default {
    data(){
        return {
            infoOpen:false
        }
    },
   
    props:{
        productId:{
            default:""
        }
    },

    mounted:function(){
        // this.quantity = this.productTotal
    },

    computed:{
        quantity:{
            set:function(val){
                let diff = val - this.quantity;
                if( diff > 0  ){
                    this.$store.dispatch('ShoppingCartStore/addProduct', {productId:this.productId, total:diff} )
                }else if( diff < 0  ){
                    this.$store.dispatch('ShoppingCartStore/removeProduct',  {productId:this.productId, total:(diff*-1)} ) 
                }
            },
            get:function(){
                return this.$store.getters['ShoppingCartStore/totalForProductId'](this.productId)
            }
        },
        product:function(){
            return this.$store.getters['EventStore/getProductById'](this.productId);
        },
        productTotal:function(){
            return false;
            // return this.$store.getters.getProductTotal(this.productid);
        }
    },

}
</script>

<style lang="stylus" >

    .product-selector{
        // width 100%;
        // display:inline-flex;
        // align-items center;
        // padding:0.5em 0.5em;
        background var(--product-selector-bg-color,gray);
        color var(--product-selector-color,black);
        border-radius:8px;
        font-weight bolder;
        .name{
            margin-top: 0.5em;
            font-size:var(--product-selector-name-size,1.5rem);
            color:var(--product-selector-name-color,1.5rem);
            line-height 1
        }
        .quantity-selector .quantity-chooser{
                // background rgba(white,0.5);
                padding:1em;
                border-radius 10px;
                color:black;
                
                input{
                    color:white !important;
                    font-weight bold
                }
                .btn.plus{
                    color: var(--product-selector-quantity-plus-color, white) !important;
                    size: var(--product-selector-quantity-plus-size, 2em) !important;
                }
            
        }

        .price-wrap{
            margin-top 4px;
            .price{
                display:block;
                line-height 0.9
            }
            .antiqueprice{
                text-decoration line-through
                opacity 0.7
            }

        }
        
    }
    
</style>
